import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { VALIDATE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'VocItemSuggestionsCountForSingleItemAgg',
    productArea: VOC,
    subProductArea: VALIDATE,
    responseFormat: 'row',
    build: ({ type = 'idea', vocItemId }) => {
        const idField = type === 'idea' ? 'leftId' : 'rightId';

        const pipeline = o.pipeline(
            o.sources.suggestions({
                state: 'pending',
                type: 'ideaAndFeedbackItem',
            }),
            o.filter(`${idField} == "${vocItemId}"`),
            o.reduce({ total: o.count(null) }),
        );

        return pipeline;
    },
};
